import { render, staticRenderFns } from "./BaseSaveButton.vue?vue&type=template&id=2cc7a6be&"
import script from "./BaseSaveButton.vue?vue&type=script&lang=js&"
export * from "./BaseSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports